import { Conversation } from './types/Conversation';
import { MakeCall } from './createMakeCall';

export interface Payload {
  documentUuid: string;
}

const linkDocumentToConversation =
  (makeCall: MakeCall) => (conversationId: number, data: Payload) =>
    makeCall<Conversation>(
      'PUT',
      `/api/v2/conversation/${conversationId}/document`,
      { data },
    );
export { linkDocumentToConversation };
